import * as React from "react";
import type { SVGProps } from "react";
const SvgLuggage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#luggage_svg__a)">
      <path d="M16.34 22H7.66C6.2 22 5 20.81 5 19.34V8.66C5 7.19 6.19 6 7.66 6h8.68C17.8 6 19 7.19 19 8.66v10.69c0 1.47-1.19 2.66-2.66 2.66zM7.66 8a.66.66 0 0 0-.66.66v10.69c0 .36.29.66.66.66h8.68c.36 0 .66-.29.66-.66V8.66a.66.66 0 0 0-.66-.66z" />
      <path d="M14 7.79c-.55 0-1-.45-1-1V2h-2v4.79c0 .55-.45 1-1 1s-1-.45-1-1V1c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v5.79c0 .55-.45 1-1 1M9 24c-.55 0-1-.45-1-1v-1.22c0-.55.45-1 1-1s1 .45 1 1V23c0 .55-.45 1-1 1M15 24c-.55 0-1-.45-1-1v-1.22c0-.55.45-1 1-1s1 .45 1 1V23c0 .55-.45 1-1 1" />
    </g>
    <defs>
      <clipPath id="luggage_svg__a">
        <path fill="#fff" d="M5 0h14v24H5z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLuggage;
